<template>
	<div class="Release">
		<el-form
				:model="selectForm"
				ref="selectForm"
				:label-position="labelPosition"
				label-width="120"
				inline
				class="custom-formScreen"
		>
			<el-form-item
					label="选择分公司"
					prop="branchCompany"
					v-if="
							[1].includes(str.type) &&
								str.superDepartmentName !== '客服部' &&
								str.superDepartmentName !== '常规客服部'
						"
			>
				<el-select
						v-model="value6"
						placeholder="请选择"
						@change="shopChange6"
						value-key="company_id"
						filterable
				>
					<el-option
							v-for="item in arr6"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
					label="选择子公司"
					prop="sonCompany"
					v-if="[2, 1].includes(str.type)"
			>
				<el-select
						v-model="value7"
						placeholder="请选择"
						value-key="rid"
						@change="shopChange7"
						filterable >
					<el-option
							v-for="item in arr7"
							:key="item.company_id"
							:label="item.companyName"
							:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择分部门" v-if="!disabledInput2">
				<el-select
						v-model="value2"
						filterable
						placeholder="请选择"
						@change="shopChange2"
				>
					<el-option
							v-for="item2 in this.arr1"
							:key="item2.value"
							:label="item2.departmentName"
							:value="item2"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="选择组" v-if="!disabledInput3">
				<el-select
						v-model="value3"
						filterable
						placeholder="请选择"
						@change="shopChange3"
				>
					<el-option
							v-for="item3 in this.arr2"
							:key="item3.value"
							:label="item3.groupName"
							:value="item3"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="选择员工" v-if="!disabledInput4">
				<el-select
						v-model="value4"
						filterable
						placeholder="请选择"
						@change="shopChange4"
				>
					<el-option
							v-for="item4 in this.arr3"
							:key="item4.value"
							:label="item4.roleUserName"
							:value="item4"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择店铺" prop="shopvalue">
				<el-select
						v-model="value5"
						filterable
						placeholder="请选择"
						clearable
						@change="shopChange5"
				>
					<el-option
							v-for="item5 in this.arr4"
							:key="item5.value"
							:label="item5.shopName"
							:value="item5"
							:style="{ color: item5.state === 0 ? 'red' : '' }"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="开始日期" prop="startTime">
				<el-date-picker
						v-model="selectForm.startTime"
						align="right"
						type="datetime"
						placeholder="选择日期"
						format="yyyy-MM-dd HH:mm:ss"
						:picker-options="pickerOptions"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="结束日期" prop="endTime">
				<el-date-picker
						v-model="selectForm.endTime"
						align="right"
						type="datetime"
						placeholder="选择日期"
						format="yyyy-MM-dd HH:mm:ss"
						:picker-options="pickerOptions"
				></el-date-picker>

			</el-form-item>
			<el-input clearable placeholder="请输入查询内容" v-model="selectForm.searchStr" style="width: 360px;margin-top: 3px" @input="selectForm.searchStr = selectForm.searchStr.replace(/\s+/g, '')">
				<el-select v-model="selectForm.searchType" slot="prepend" style="width: 100px" clearable>
          <el-option label="ParentSKU" value="1"></el-option>
          <el-option label="产品编号" value="3"></el-option>
          <el-option label="标题" value="4"></el-option>
          <el-option label="备注" value="5"></el-option>
				</el-select>
			</el-input>
			<el-button
					type="primary"
					style="margin-left: 10px;"
					@click="search"
			>搜索</el-button>
			<el-button type="primary" @click="searchReset">重置</el-button>
		</el-form>
		<div class="summary_bag">
			<div class="summary_complete_bag">
				<div class="status_button">
					<el-radio-group v-model="selectForm.onlineStatus" style="margin-bottom: 30px;" @change="changeStatus">
						<el-radio-button label="88">全部</el-radio-button>
            <el-radio-button label="0">草稿</el-radio-button>
            <el-radio-button label="1">上架中</el-radio-button>
						<el-radio-button label="2">在售</el-radio-button>
						<el-radio-button label="3">已下架</el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<!-- 符合查询条件的产品共-->
			<div class="summary_pagenum">
				<div class="summary_query">
					符合查询条件的产品共
					<span>{{ count }}</span>
					件
				</div>
			</div>
			<div class="summary_content">
				<div class="summary_batch">
					<span>已选择产品{{ piece }}件</span>
					<template>
						<span @click="piliangTongbu" style="cursor:pointer">同步</span>
						<span @click="piliangEdit" style="cursor:pointer">批量编辑</span>
            <span @click="clickXiajia" style="cursor:pointer">批量下架</span>
            <span @click="clickShangjia" style="cursor:pointer">批量上架</span>
					</template>
				</div>
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
							:data="tableList"
							style="width: 100%"
							v-loading="load_data"
							element-loading-text="拼命加载中"
							border
							@selection-change="on_batch_select"
							:header-cell-style="iscenter"
							stripe
							class="pg-table"
							:cell-class-name="'pg-cell'"
							:header-cell-class-name="'pg-header-cell'"
							fit

					>
						<el-table-column
								width="50"
								type="selection"
								align="center"
						></el-table-column>
						<el-table-column
								label="图片"
								width="90"
								align="left"
						>
							<template slot-scope="scope">
								<el-popover trigger="hover" placement="right" :open-delay="600" v-if="scope.row.images && scope.row.images.length > 0">
									<img
											:src="scope.row.images[0]"
											class="prduct_img"
											alt
									/>
									<div class="scope_img" slot="reference">
										<img
												:src="scope.row.images[0]"
												alt
										/>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column
								label="标题/offerId/店铺/分类"
								prop="productNumber"
								align="left"
								min-width="240"
						>
							<template slot-scope="scope">
								<div>
                  <el-popover trigger="hover" placement="top-start" :open-delay="600">
                    <span @click="copyTextToClipboard('https://allegro.pl/oferta/'+ scope.row.name.trim() +'-'+ scope.row.offerId)">
                      {{ 'https://allegro.pl/oferta/'+ scope.row.name.trim() +'-'+ scope.row.offerId }}
                    </span>
                    <div slot="reference">
                      <el-link
                          :href="'https://allegro.pl/oferta/'+ scope.row.name.trim() +'-'+ scope.row.offerId"
                          target="_blank"
                          type="primary"
                      >{{scope.row.name}}</el-link>
                    </div>
                  </el-popover>
								</div>
								<div @click="copyTextToClipboard(scope.row.offerId)">{{scope.row.offerId}}</div>
								<div>{{scope.row.shopName}}</div>
                <div>
                  <el-popover trigger="hover" placement="top-start" :open-delay="600">
                    <span @click="copyTextToClipboard(scope.row.cnFullName)">
                      {{scope.row.cnFullName }}
                    </span>
                    <div slot="reference" style="cursor: pointer">
                      {{scope.row.cnFullName}}
                    </div>
                  </el-popover>
                 </div>
							</template>
						</el-table-column>
						<el-table-column
								label="操作"
								:width="110"
								align="center"
						>
							<template slot-scope="scope">
								<template>

									<!-- <div>
										<el-button
											type="primary"
											v-if="system == 5"
											@click="clickEdit(scope.row)"
									>编辑</el-button>
									</div> -->
									<div>
										<el-button
												type="primary"
												v-if="system == 5"
												@click="piliangTongbu(scope.row)"
										>同步</el-button>
									</div>
									<!--审核中不显示-->
									<el-button
											type="primary"
											v-if="system < 5"
											@click="clickEdit(scope.row,'chakan')"
									>查看</el-button>
                  <!--审核中不显示-->
                  <el-button
                      type="primary"
                      v-if="system == 5 && scope.row.onlineStatus == 2"
                      @click="clickXiajia(scope.row)"
                  >下架</el-button>
                  <!--审核中不显示-->
                  <el-button
                      type="primary"
                      v-if="system == 5 && scope.row.onlineStatus == 3"
                      @click="clickShangjia(scope.row)"
                  >上架</el-button>
								</template>
							</template>
						</el-table-column>
            <el-table-column prop="title" label="状态"
                             :width="100"
                             align="center">
              <template slot-scope="scope">
                <div style="display: flex;flex-direction: column">
                  <div v-if="scope.row.onlineStatus" class="item_sku">
                    <el-tag v-if="scope.row.onlineStatus == 0">草稿</el-tag>
                    <el-tag v-if="scope.row.onlineStatus == 1">上架中</el-tag>
                    <el-tag v-if="scope.row.onlineStatus == 2" type="success">在售</el-tag>
                    <el-tag v-if="scope.row.onlineStatus == 3" type="danger">已下架</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
						<el-table-column prop="sku" label="SKU" min-width="200"
										 align="center" show-overflow-tooltip>
              <template slot-scope="scope">
               <span @click="copyTextToClipboard(scope.row.sku)"> {{scope.row.sku}}</span>
              </template>
						</el-table-column>
            <el-table-column label="波兰(PLN)" min-width="120"
                             align="center">
              <template slot-scope="scope">
               {{scope.row.sellingMode ? JSON.parse(scope.row.sellingMode).price.amount :''}}
              </template>
            </el-table-column>
            <el-table-column label="捷克(CZK)" min-width="120"
                             align="center">
              <template slot-scope="scope">
              {{returnCzkPrice(scope.row,'allegro-cz') }}
              </template>
            </el-table-column>
            <el-table-column label="斯洛伐克(EUR)" min-width="120"
                             align="center">
              <template slot-scope="scope">
              {{returnCzkPrice(scope.row,'allegro-sk') }}
              </template>
            </el-table-column>
            <el-table-column label="库存/售出" width="100"
                             align="center">
              <template slot-scope="scope">
                <div style="display: flex;flex-direction: column">
                  <div v-if="scope.row.uploadTime" class="item_sku">
                    <el-tag style="line-height: 18px;height: 18px">库</el-tag>
                    <span style="margin-left: 3px">
                      {{scope.row.currentStock? JSON.parse(scope.row.currentStock).available :'0'}}
                    </span>
                  </div>
                  <div v-if="scope.row.updateTime" class="item_sku" style="margin-top: 3px">
                    <el-tag style="line-height: 18px;height: 18px">售</el-tag>
                    <span style="margin-left: 3px">
                      {{scope.row.currentStock? JSON.parse(scope.row.currentStock).sold :'0'}}
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>
						<el-table-column label="关注/访问数" width="100"
										 align="center">
							<template slot-scope="scope">
								<div style="display: flex;flex-direction: column">
									<div v-if="scope.row.uploadTime" class="item_sku">
										<el-tag style="line-height: 18px;height: 18px">关</el-tag>
                    <span style="margin-left: 3px">
                      {{scope.row.stats? JSON.parse(scope.row.stats).visitsCount :'0'}}
                    </span>
									</div>
									<div v-if="scope.row.updateTime" class="item_sku" style="margin-top: 3px">
										<el-tag style="line-height: 18px;height: 18px">访</el-tag>
                    <span style="margin-left: 3px">
                      {{scope.row.stats? JSON.parse(scope.row.stats).watchersCount :'0'}}
                    </span>
									</div>
								</div>
							</template>
						</el-table-column>
            <el-table-column prop="title" label="发布/修改/下架时间" width="220"
                             align="left">
              <template slot-scope="scope">
                <div style="display: flex;flex-direction: column">
                  <div v-if="scope.row.uploadTime" class="item_sku">
                    <el-tag style="line-height: 18px;height: 18px">发</el-tag>	<span style="margin-left: 3px">{{scope.row.uploadTime}}</span>
                  </div>
                  <div v-if="scope.row.updateTime" class="item_sku" style="margin-top: 3px">
                    <el-tag style="line-height: 18px;height: 18px">修</el-tag>	<span style="margin-left: 3px">	{{scope.row.updateTime}}</span>
                  </div>
                  <div v-if="scope.row.removedTime" class="item_sku" style="margin-top: 3px">
                    <el-tag style="line-height: 18px;height: 18px">下</el-tag>	<span style="margin-left: 3px">	{{scope.row.removedTime}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

					</el-table>
					<div class="summary_pagenum_block">
						<div class="block">
							<el-pagination
									@current-change="handleCurrentChange"
									:current-page="currentPage"
									@size-change="handleSizeChange"
									:page-sizes="[10, 20, 50, 100]"
									layout="total, sizes, prev, pager, next, jumper"
									:total="count"
							></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="批量编辑" :visible.sync="dialogPiliangEdit"
				   width="80%"
				   top="5vh">
			<!-- 头部 -->
			<el-table
					:data="piliangList"
					style="width: 100%"
					border
					:header-cell-style="iscenter"
					class="pg-table"
					:cell-class-name="'pg-cell'"
					:header-cell-class-name="'pg-header-cell'"
			>
				<el-table-column
						label="图片"
						:width="100"
						align="left"
				>
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="right" :open-delay="600" v-if="scope.row.images && scope.row.images.length > 0">
							<img
									:src="scope.row.images[0]"
									class="prduct_img"
									alt
							/>
							<div class="scope_img" slot="reference">
								<img
										:src="scope.row.images[0]"
										alt
								/>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
						label="标题"
						align="left"
						show-overflow-tooltip
						min-width="15%"
				>
					<template slot-scope="scope">
            <el-input v-model="scope.row.name" :disabled="system < 5"></el-input>
					</template>
				</el-table-column>
        <el-table-column
            align="left"
            show-overflow-tooltip
            min-width="15%" prop="wuliumuban"
        >
          <template slot="header" slot-scope="scope">
            <div class="item_header_title"><span class='item_bitian'>*</span>物流模版</div>
            <div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
          </template>
          <template slot-scope="scope">
            <el-input v-model="scope.row.wuliumuban" :disabled="system < 5"></el-input>
          </template>
        </el-table-column>
				<el-table-column min-width="15%" prop="bolanPrice">
					<template slot="header" slot-scope="scope">
					<div class="item_header_title"><span class='item_bitian'>*</span>波兰(PLN)</div>
					<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
						<div class="item_header_title"><el-link type="primary" @click="clickDingjia(scope)" v-if="system == 5">定价计算</el-link></div>
					</template>
					<template slot-scope="scope">
						<el-input v-model="scope.row.bolanPrice" :disabled="system < 5"
								  oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"></el-input>
					</template>
				</el-table-column>
        <el-table-column min-width="15%" prop="jiekePrice">
          <template slot="header" slot-scope="scope">
            <div class="item_header_title"><span class='item_bitian'>*</span>捷克(CZK)</div>
            <div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
            <div class="item_header_title"><el-link type="primary" @click="clickHuansuan(scope)" v-if="system == 5 && !isChakan">自动换算</el-link></div>
          </template>
          <template slot-scope="scope">
            <el-input v-model="scope.row.jiekePrice" :disabled="system < 5"
                      oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"></el-input>
          </template>
        </el-table-column>
        <el-table-column min-width="15%" prop="siluofakePrice">
          <template slot="header" slot-scope="scope">
            <div class="item_header_title"><span class='item_bitian'>*</span>斯洛伐克(EUR)</div>
            <div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
            <div class="item_header_title"><el-link type="primary" @click="clickHuansuan(scope)" v-if="system == 5 && !isChakan">自动换算</el-link></div>
          </template>
          <template slot-scope="scope">
            <el-input v-model="scope.row.siluofakePrice" :disabled="system < 5"
                      oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')"></el-input>
          </template>
        </el-table-column>
				<el-table-column
								 min-width="15%"
								 align="left"  prop="stock">
					<template slot="header" slot-scope="scope">
						<div class="item_header_title"><span class='item_bitian'>*</span>库存</div>
						<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5">同首行</el-link></div>
					</template>
					<template slot-scope="scope">
						<el-input v-model="scope.row.stock" :disabled="system < 5" oninput ="value=value.replace(/[^0-9]/g,'')"></el-input>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" style="margin-top: 60px">
					<el-button @click="dialogPiliangEdit = false">取 消</el-button>
					<el-button :loading="loadingStatus" v-if="system == 5 && !isChakan" type="primary" @click="editSaveAndfabu" style="margin-right: 30px">保存并发布</el-button>
  			</span>
		</el-dialog>

		<dingjia ref="dingjia" @changeDingjia="changeDingjia"/>
	</div>
</template>

<script>
	import { ajaxPost, Baseurl,ajaxGet } from '@/api/api/api'
	import dingjia from './components/dingjia.vue'
	export default {
		name: 'productDisplay',
		components: {
			dingjia
		},
		data() {
			return {
        loadingStatus:false,
        //捷克与波兰的汇率比
        jiekehuilv:1,
        //斯洛伐克与波兰的汇率比
        siluofakehuilv:1,
				isChakan:false,
				//选中产品的id
				onlineProductId:'',
				ozonProductId:'',
				dingjiaStatus:'',
				title:'添加产品',
				//在线产品编辑
				onlineEdit:false,
				dialogPiliangEdit:false,
				//批量编辑列表
				piliangList:[],
				resultContent:'',
				//是否为编辑
				isEdit:false,
				bianjiProductId:'',
				loading:null,
				dialogLoding:false,
				batch_select:[],
				productImgArr: [],
				fuzhiId:'',
				//复制店铺的
				fuzhiDianpuObj:{},
				//仓库id
				warehouseId:'',
				//仓库列表
				warehouseIdList:[],
				//选择店铺获得的sellerid
				sellerId:'',
				//选择店铺获得的ShopId
				markShopId:'',
				show:'',
				state:'',
				strSeller:'',
				//标识 1boss 2 部长 3分部长 4 组长 5普通员工
				system:'5',
				//角色id
				rid:'',
				labelPosition: 'right',

				str: '',
				value2: '',
				//组
				value3: '',
				//员工
				value4: '',
				//店铺
				value5: '',
				//分公司
				value6: '',
				//子公司
				value7: '',
				arr: [],
				arr1: [],
				arr2: [],
				arr3: [],
				arr4: [],
				arr5: [],
				arr6: [],
				arr7: [],
				//平台名称
				sellerType: '11',
				disabledInput: '',
				disabledInput2: '',
				disabledInput3: '',
				disabledInput4: '',
				dianpuForm:{},
				selectForm: {
					page: 1,
					size: 20,
					//查询类型
					searchType:'1',
					//查询内容
					searchStr:'',
					startTime: '', //开始时间
					endTime: '', //结束时间
					timeType:1,
					//角色id
					staffId: "",
					//店铺id
					sellerId: "",
					//公司id
					companyId:'',
					onlineStatus: 88,
					isTranslation: 1
				},
				pickerOptions: {
					shortcuts: [{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date);
							this.calculationDate()
						}
					}, {
						text: '上一月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-1)
						}
					}, {
						text: '上两月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-2)
						}
					}, {
						text: '上三月',
						onClick: (picker) => {
							const date = new Date();
							picker.$emit('pick', date);
							this.calculationDate(-3)
						}
					}]
				},
				branchCompany: [],
				pageType: '',
				dialogVisible:false,
				//提示bug弹窗
				dialogVisibleShenhe:false,
				//复制弹窗
				dialogVisibleFuzhi:false,
				//审核弹窗提示内容
				bugContentList:[],
				tabPosition:'88',
				load_data: false,
				iscenter: {
					textAlign: 'center',
					background: '#f8f8f8',
					color: '#232323',
				},
				currentPage: 1,
				size: 10,
				//page total
				count: 1,
				//已选数量
				piece: 0,
				//是否全选
				checkAll: false,
				tableList: [],
				arrOld: [],
				//公司
				sonCompanyList: [],
				//部门
				departmentList: [],
				//角色
				groupList: [],
				//店铺
				staffList: [],
				platform: [
					{"sellerType":1,"itemTypeName":"Amazon"},{"sellerType":2,"itemTypeName":"Shopify"},{"sellerType":5,"itemTypeName":"Shoplazza"},{"sellerType":7,"itemTypeName":"Shopline"}
				],
				platforms:[],
				//选中的列表
				selectTableList:[],
				bizhong:'CNY'
			}
		},
		created() {
			this.dingjiaStatus = ''
			this.sellerId = ''
			this.markShopId = ''
			this.str = JSON.parse(localStorage.getItem('role'))
			this.rid = this.str.rid
			this.selectForm.staffId = this.str.rid
			this.selectForm.companyId = this.str.company_id
			this.strSeller = JSON.parse(localStorage.getItem('sellerInfo'))
			this.show = this.str.system
			this.system = this.str.system
			this.state = this.str.system
      this.getBizhong()
			this.init()
			//获取表格数据
			this.get_table_data()
		},
		methods: {
			init() {
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: this.str.rid,
					system: this.str.system,
					companyId: this.str.company_id,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr = res.data.data.next
					this.bizhong = (this.arr && this.arr.length > 0 && this.arr[0].currencyCode) ? this.arr[0].currencyCode:'CNY'
					const { type: companyType } = this.str
					if (
							companyType === 1 &&
							this.str.superDepartmentName !== '客服部' &&
							this.str.superDepartmentName !== '常规客服部'
					) {
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr6 = res.data.data.next
					} else if (
							companyType === 2 ||
							(companyType === 1 &&
									this.str.superDepartmentName === '客服部') ||
							(companyType === 1 &&
									this.str.superDepartmentName === '常规客服部')
					) {
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr7 = res.data.data.next
					} else if (
							this.state === 1 ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '财务部') ||
							(this.str.type === 3 &&
									this.str.system === 5 &&
									this.str.superDepartmentName === '人事部')
					) {
						this.disabledInput = false
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr1 = res.data.data.next
					} else if (this.state === 2) {
						this.disabledInput = true
						this.disabledInput2 = false
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr1 = res.data.data.next
					} else if (this.state === 3) {
						this.disabledInput = true
						this.disabledInput2 = true
						this.disabledInput3 = false
						this.disabledInput4 = false
						this.arr2 = res.data.data.next
					} else if (this.state === 4) {
						this.disabledInput = true
						this.disabledInput2 = true
						this.disabledInput3 = true
						this.disabledInput4 = false
						this.arr3 = res.data.data.next
					} else if (this.state === 5) {
						this.disabledInput = true
						this.disabledInput2 = true
						this.disabledInput3 = true
						this.disabledInput4 = true
						var sellerInfos = res.data.data.next
						var newArr = []
						var num = 0
						for (var i = 0; i < sellerInfos.length; i++) {
							var shop = sellerInfos[i].countryMarks
							var sellerId = sellerInfos[i].sellerId
							for (var j = 0; j < shop.length; j++) {
								shop[j].sellerId = sellerId
								newArr[num] = shop[j]
								// newArr[num] = shop[j];
								num++
							}
						}
						this.arr4 = newArr
						// this.arr4 = newArr.sort((a, b) => a.order - b.order);
					}
				})
			},
			calculationDate(type = 0) {
				const date = new Date()
				const year = date.getFullYear()
				const month = date.getMonth() + 1
				const day = date.getDate()
				// 计算新的月份和年份，确保处理负数和跨年的情况
				const newYear = year + Math.floor((month + type - 1) / 12);
				const newMonth = (month + type - 1 + 12) % 12 + 1;
				this.selectForm.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;

				const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
				const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
				this.selectForm.endTime = `${prevMonth} 23:59:59`
			},
			//获取表格数据
			get_table_data() {
				var that = this
				this.load_data = true
				var begin = this.selectForm.startTime
				if (begin == null || begin == '') {
					begin = ''
				} else {
					begin =
							new Date(this.selectForm.startTime)
									.toLocaleDateString()
									.replace(/\//g, '-') +
							' ' +
							new Date(this.selectForm.startTime)
									.toTimeString()
									.substr(0, 8)
				}
				var end = this.selectForm.endTime
				if (end == null || end == '') {
					end = ''
				} else {
					end =
							new Date(this.selectForm.endTime)
									.toLocaleDateString()
									.replace(/\//g, '-') +
							' ' +
							new Date(this.selectForm.endTime).toTimeString().substr(0, 8)
				}
				//将startTime格式强转
				let searchobj  =Object.assign({}, this.selectForm, {
					startTime:begin,
					endTime:end,
					page: this.currentPage,
					size: this.size,
				})
				ajaxPost(Baseurl + 'allegroOfferInfo/selectAllegroOnlineProducts', searchobj).then(
						(res) => {
							this.load_data = false
							const { code, message, data } = res.data
							if (code == 200) {
								this.tableList = data.list.map(item => {
									item.isShowAll = false
									item.images = JSON.parse(item.images)
									return item
								})
								this.count = data.total
							} else {
								this.$message.error(message)
							}
						}
				).catch(function(e) {
				})
			},
			//修改size
			handleSizeChange(val) {
				this.size = val
				this.get_table_data()
			},
			//修改current
			handleCurrentChange(val) {
				this.currentPage = val
				this.get_table_data()
			},
			//左侧勾选项变化
			on_batch_select(val) {
				var newarr = []
				this.piece = val.length
				for (var i = 0; i < val.length; i++) {
					newarr.push(val[i].id)
				}
				this.batch_select = newarr
				this.selectTableList = val
				// this.batch_select = val;
			},
			shopChange2(value2) {
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.rid = value2.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value2.rid,
					system: 3,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr2 = res.data.data.next
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange3(value3) {
				this.arr4 = []
				this.arr5 = []
				this.value4 = ''
				this.value5 = ''
				this.rid = value3.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value3.rid,
					system: 4,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					this.arr3 = res.data.data.next
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange4(value4) {
				this.arr5 = []
				this.value5 = ''
				this.rid = value4.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value4.rid,
					system: 5,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					var sellerInfos = res.data.data.next
					var newArr = []
					var ids = []
					var num = 0
					for (var i = 0; i < sellerInfos.length; i++) {
						var shop = sellerInfos[i].countryMarks
						for (var j = 0; j < shop.length; j++) {
							newArr[num] = shop[j]
							ids[num] = shop[j].shopId
							num++
						}
					}
					this.arr4 = newArr
					this.shopIds = res.data.data.shopIds
				})
			},
			shopChange5(value5) {
				this.shopIds = [value5.shopId]
				this.markShopId =value5.shopId
				this.selectForm.sellerId = value5.sellerId
			},
			shopChange6(value6) {
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.arr7 = []
				this.value1 = ''
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.value7 = ''
				this.selectForm.companyId = value6.company_id
				this.rid = value6.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value6.rid,
					system: 1,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr7 = data.next
						this.shopIds = data.shopIds
					}
				})
			},
			shopChange7(value7) {
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.value1 = ''
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.selectForm.companyId = value7.company_id
				this.sellerType='';
				this.rid = value7.rid
				ajaxPost(Baseurl + 'roleController/selectNextAndSellerInfoByRid', {
					rid: value7.rid,
					system: 1,
					companyId: this.selectForm.companyId,
					sellerType: this.sellerType
				}).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr1 = data.next
						this.shopIds = data.shopIds
					}
				})
				this.getItemList();
			},
			search() {
				this.currentPage = 1
				this.get_table_data()
			},
			// 重置
			searchReset() {
				this.selectForm.startTime = undefined
				this.selectForm.endTime = undefined
				this.selectForm.searchStr = undefined
				this.selectForm.searchType = '1'
				this.selectForm.sellerId = ''
				this.input = ''
				this.selectForm.Ymxvalue = ''
				this.selectForm.demandValue = ''
				this.selectForm.purchaseValue = ''
				this.selectForm.domesticvalue = ''
				this.selectForm.domesticLogisticsStatus = ''
				this.selectForm.internationalLogisticsStatus = ''
				this.selectForm.purchaseEstimated = ''
				this.selectForm.logisticsEstimated = ''
				this.selectForm.channelStatus = ''
				this.selectForm.countryMark = ''
				// this.selectForm.startTime = ''
				// this.selectForm.endTime = ''
				this.selectForm.systemSku = ''
				this.selectForm.sku = ''

				this.selectForm.resource1 = ''
				this.selectForm.resource2 = ''
				this.selectForm.resource3 = ''
				this.selectForm.resource4 = ''
				;(this.purchaseMark = ''),
						(this.channelMark = ''),
						(this.orderMark = '')
				this.orderType = '';
				this.currentPage = 1
				this.size = 20
				this.arr1 = []
				this.arr2 = []
				this.arr3 = []
				this.arr4 = []
				this.arr5 = []
				this.arr6 = []
				this.arr7 = []
				// this.value1 = "";
				this.value2 = ''
				this.value3 = ''
				this.value4 = ''
				this.value5 = ''
				this.value6 = ''
				this.value7 = ''
				this.sellerType = ''

				this.orderStatus = ''
				this.purchaseDemandStatus = ''

				this.selectForm.internalConveyNumber = ''
				this.selectForm.conveyNumber = ''

				var str = JSON.parse(localStorage.getItem('role'))
				this.state = str.system
				this.rid = str.rid
				this.init()
				this.get_table_data()
			},
			//选择开始时间
			startTime(val) {
				var d = new Date(val)
				var datetime =
						d.getFullYear() +
						'-' +
						(d.getMonth() + 1) +
						'-' +
						d.getDate() +
						' 00:00:00'
				this.selectForm.startTime = datetime
			},
			// 选择结束时间
			endTime(val) {
				var d = new Date(val)
				var datetime =
						d.getFullYear() +
						'-' +
						(d.getMonth() + 1) +
						'-' +
						d.getDate() +
						' 23:59:59'
				this.selectForm.endTime = datetime
			},
			//修改状态，请求数据接口
			changeStatus(){
				this.currentPage = 1
				this.get_table_data()
			},
			clickEdit(row,type){
				this.onlineProductId = row.id
				this.ozonProductId = row.ozonProductId
				this.title = type == 'chakan' ? '查看产品':'编辑产品'
				this.isEdit = true
				this.dialogVisible = true
				this.onlineEdit = true
				this.dialogLoding = true
				const API = Baseurl + 'ozonProductVariant/getOzonOnlineProductInfo'
				let params = {
					ozonProductId: row.ozonProductId,
					offerId: row.offerId,
					sellerId: row.sellerId
				}

				let cangkuParams = {
					sellerId: row.sellerId
				}
				ajaxPost(API, params)
						.then((res) => {
							if(res.data.code === 200) {
								let dianpuParams ={
									rid: this.str.rid,
									system: this.str.system,
									companyId: this.str.company_id,
									sellerType: ''
								}

								//获取店铺列表
								this.$refs.baseInfo.getdianpuList(dianpuParams)

								this.$refs.baseInfo.onlineEdit = true
								this.$refs.baseInfo.formData.sku = row.parentSku
								this.$refs.onlineBianti.ParentSKU = row.parentSku
								this.$refs.baseInfo.allLeimuName = row.typeName + '('+row.typeNameCn +')'
								this.$refs.baseInfo.formData.categoryId = row.categoryId
								this.$refs.baseInfo.formData.typeId = row.typeId
								this.$refs.baseInfo.formData.sellerId = row.sellerId
								this.$refs.baseInfo.formData.name = row.name

								this.$refs.uploadPictures.imgListSelect = row.images
								this.productImgArr = row.images
								this.$refs.wuliu.formData.warehouseId = row.warehouseId
								this.selectForm.staffId = row.staffId
								this.$refs.baseInfo.formData.shopId = row.countrySellerId
								this.$refs.baseInfo.formData.sellerId = row.sellerId
								this.$refs.onlineBianti.ParentSKU = row.parentSku
								this.$refs.onlineBianti.ParentName = row.name
								this.selectForm.companyId = row.companyId

								this.$refs.onlineBianti.ParentName = row.name
								this.$refs.onlineBianti.tableList[0].offerId = row.offerId
								this.$refs.onlineBianti.tableList[0].oldPrice = res.data.data.productInfo.old_price//原价
								this.$refs.onlineBianti.tableList[0].price = res.data.data.productInfo.price//现价
								this.$refs.onlineBianti.tableList[0].stock = parseInt(res.data.data.productInfo.stocks.coming) + parseInt(res.data.data.productInfo.stocks.present) +parseInt(res.data.data.productInfo.stocks.reserved) //库存
								this.$refs.onlineBianti.tableList[0].imageList = res.data.data.productInfo.images
								if (res.data.data && res.data.data.productAttributesInfo
										&& res.data.data.productAttributesInfo.length > 0){
									let productAttributesInfo = res.data.data.productAttributesInfo[0]
									this.$refs.wuliu.formData.depth = productAttributesInfo.depth
									this.$refs.wuliu.formData.dimensionUnit = productAttributesInfo.dimension_unit
									this.$refs.wuliu.formData.height = productAttributesInfo.height
									if (res.data.data.productInfo.vat == '0.100000'){
										this.$refs.wuliu.formData.vat = '0.1'
									} else if (res.data.data.productInfo.vat == '0.200000'){
										this.$refs.wuliu.formData.vat = '0.2'
									} else if(res.data.data.productInfo.vat == '0.0'){
										this.$refs.wuliu.formData.vat = '0'
									}

									this.$refs.wuliu.formData.weight = productAttributesInfo.weight
									this.$refs.wuliu.formData.weightUnit = productAttributesInfo.weight_unit
									this.$refs.wuliu.formData.width = productAttributesInfo.width

									if (type == 'chakan'){
										this.isChakan = true
										this.$refs.baseInfo.isChakan = true
										this.$refs.description.isChakan = true
										this.$refs.laiyuan.isChakan = true
										this.$refs.wuliu.isChakan = true
										this.$refs.onlineBianti.isChakan = true
										this.$refs.uploadPictures.isChakan = true
									} else {
										this.isChakan = false
										this.$refs.baseInfo.isChakan = false
										this.$refs.description.isChakan = false
										this.$refs.laiyuan.isChakan = false
										this.$refs.wuliu.isChakan = false
										this.$refs.onlineBianti.isChakan = false
										this.$refs.uploadPictures.isChakan = false
									}
									//变体属性
								//	let productInfo = res.data.data.productInfo
									let zhuAttributes = res.data.data.productAttributesInfo[0].attributes
									zhuAttributes.forEach(item => {
										//文字描述
										if (item.attribute_id == '4191'){
											this.$refs.description.formData.descValue = item.values[0].value
										}
										//尺寸表
										if (item.attribute_id == '13164'){
											this.$refs.description.formData.chicunValue = item.values[0].value
										}
										//丰富内容
										if (item.attribute_id == '11254'){
											this.$refs.description.formData.jsonValue = item.values[0].value
										}
									})
									//	let biantizhi = []
										this.$refs.baseInfo.addStatus = 'edit'
											this.$nextTick(() => {
											this.$refs.baseInfo.getOnlineAttribute(zhuAttributes)
											});
										this.dialogLoding = false
										}
							}else{
								this.$message.error(res.data.data)
							}
						})
			},
			//批量编辑
			piliangEdit(){
				var that = this
				if (this.piece == 0) {
					this.$alert('请至少勾选一件产品！', '提示', {
						confirmButtonText: '确定',
					})
					return
				}
        let piliangLIst = JSON.parse(JSON.stringify(this.selectTableList))
        piliangLIst.forEach(item =>{
          if (item.sellingMode){
            item.bolanPrice = JSON.parse(item.sellingMode).price.amount
          }
          if (item.additionalMarketplaces){
            item.additionalMarketplaces = JSON.parse(item.additionalMarketplaces)
          }
          if (item.additionalMarketplaces['allegro-cz'] && item.additionalMarketplaces['allegro-cz'].sellingMode && item.additionalMarketplaces['allegro-sk'].sellingMode.price){
            item.jiekePrice = item.additionalMarketplaces['allegro-cz'].sellingMode.price.amount
          }
          if (item.additionalMarketplaces['allegro-sk'] && item.additionalMarketplaces['allegro-sk'].sellingMode && item.additionalMarketplaces['allegro-sk'].sellingMode.price){
            item.siluofakePrice = item.additionalMarketplaces['allegro-sk'].sellingMode.price.amount
          }
          if (item.stock){
            item.oldStock = JSON.parse(item.stock)
            item.stock = JSON.parse(item.stock).available
          }
        })
				this.piliangList = [...piliangLIst]
				this.dialogPiliangEdit = true
			},

			//同首行
			clickHeader(scope){
				let property = scope.column.property
				this.piliangList.forEach(item =>{
					item[property] = this.piliangList[0][property]
				})
			},

			//定价计算
			clickDingjia(scope){
				this.$refs.dingjia.isshowBeizhu = false
				if (this.dingjiaStatus != 'click'){
					this.dingjiaStatus = 'click'
					this.$refs.dingjia.dialogVisible = true
					this.$refs.dingjia.ruleForm.caigoudanjia = undefined
					this.$refs.dingjia.ruleForm.leimuyongjin = undefined
					this.$refs.dingjia.ruleForm.guanggao = 9
					this.$refs.dingjia.ruleForm.caigouyunfei = undefined
					this.$refs.dingjia.ruleForm.tixianshouxu = 0.7
					this.$refs.dingjia.ruleForm.cuxiaohuodong = 15
					this.$refs.dingjia.ruleForm.zhongliang = undefined
					this.$refs.dingjia.ruleForm.jinglilv = 20
					this.$refs.dingjia.ruleForm.yuguyunfei = undefined
					this.$refs.dingjia.ruleForm.shoujia = undefined
					this.$refs.dingjia.ruleForm.beizhuguocheng = undefined
				} else {
					this.$refs.dingjia.dialogVisible = true
				}

			},
			changeDingjia(val){
				this.piliangList.forEach(item =>{
					item.bolanPrice = val
				})
			},
			//批量编辑保存并发布
			editSaveAndfabu(){
				let issaveStatus = true
        try {
          this.piliangList.forEach(item => {
            if (!item.name || !item.bolanPrice || !item.jiekePrice || !item.siluofakePrice || item.stock == '' ){
              issaveStatus = false
            }
          })
        } catch (e){
          console.log(e)
        }

				if (!issaveStatus){
					this.$message({
						type: 'info',
						message: '请填写完成所有修改内容！',
					})
					return
				}
        this.loadingStatus = true
				let params = this.piliangList.map(item=>{
					return {
            offerId: item.offerId,
            sellerId: item.sellerId,
            stockJson: {
              available: item.stock,
              unit: item.oldStock.unit
            },
            sellingModeJson: {
              format: "BUY_NOW",
              price: {
                amount: item.bolanPrice,
                currency: "PLN"
              }
            },
            additionalMarketplacesJson: {
              "allegro-cz": {
                sellingMode: {
                  price: {
                    amount: item.jiekePrice,
                    currency: "CZK"
                  }
                }
              },
              "allegro-sk": {
                sellingMode: {
                  price: {
                    amount: item.siluofakePrice,
                    currency: "EUR"
                  }
                }
              }
            }
					}
				})
				ajaxPost(
						Baseurl + 'allegroOfferInfo/batchUpdateOffer',
						params
				).then((res) => {
					if (res.data.code == 200) {
            this.loadingStatus = false
						this.dialogPiliangEdit = false
						this.$message({
							type: 'success',
							message: '批量修改成功!',
						})
						this.get_table_data()
					}
				})

			},
			//批量同步
			piliangTongbu(row){
        let params
        if (row && row.id){
          params = [{
            sellerId:row.sellerId,
            offerId:row.offerId,
          }]
        } else {
          if (this.piece == 0) {
            this.$alert('请至少勾选一件产品！', '提示', {
              confirmButtonText: '确定',
            })
            return
          }
          params = this.selectTableList.map(item =>{
            return {
              offerId: item.offerId,
              sellerId:item.sellerId
            }
          })
        }
				let that = this
				this.$confirm('此操作将同步在线产品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
						.then(() => {
							ajaxPost(
									Baseurl + 'allegroOfferInfo/batchSynchronize',
									params
							).then((res) => {
								if (res.data.code == 200) {
									that.$message({
										type: 'success',
										message: '同步成功!',
									})
									that.get_table_data()
								}
							})
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消“同步”操作',
							})
						})
			},
      returnCzkPrice(item,objKeyName) {
        let returnPrice = ''
        let jsonObj
        if (item.additionalMarketplaces){
          jsonObj = JSON.parse(item.additionalMarketplaces)
        }
        if (jsonObj[objKeyName] && jsonObj[objKeyName].sellingMode && jsonObj[objKeyName].sellingMode.price && jsonObj[objKeyName].sellingMode.price.amount){
          returnPrice = jsonObj[objKeyName].sellingMode.price.amount
        }
        return returnPrice
      },
      //下架
      clickXiajia(row){
        let params
        if (row && row.id){
          params = [{
            sellerId:row.sellerId,
            offerId:row.offerId,
          }]
        } else {
          if (this.piece == 0) {
            this.$alert('请至少勾选一件产品！', '提示', {
              confirmButtonText: '确定',
            })
            return
          }
          //筛选出不是的下标
          let findIndex = this.selectTableList.findIndex(item =>{
            return item.onlineStatus != '2'
          })
          if (findIndex != -1){
            this.$alert('勾选的第'+ (findIndex+1) +'项不属于在售状态,请确认下架内容！', '提示', {
              confirmButtonText: '确定',
            })
            return
          }
          params = this.selectTableList.map(item =>{
            return {
              sellerId:item.sellerId,
              offerId:item.offerId,
            }
          })
        }
        let that = this
        this.$confirm('此操作将下架在线产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
            .then(() => {
              ajaxPost(
                  Baseurl + 'allegroOfferInfo/batchRemoved',
                  params
              ).then((res) => {
                if (res.data.code == 200) {
                  that.$message({
                    type: 'success',
                    message: '下架成功!',
                  })
                  that.get_table_data()
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消“下架”操作',
              })
            })
      },
      //上架
      clickShangjia(row){
        let params
        if (row && row.id){
          params = [{
            sellerId:row.sellerId,
            offerId:row.offerId,
          }]
        } else {
          if (this.piece == 0) {
            this.$alert('请至少勾选一件产品！', '提示', {
              confirmButtonText: '确定',
            })
            return
          }
          //筛选出不是的下标
          let findIndex = this.selectTableList.findIndex(item =>{
            return item.onlineStatus != '3'
          })
          if (findIndex != -1){
            this.$alert('勾选的第'+ (findIndex+1) +'项不属于待下架状态,请确认上架内容！', '提示', {
              confirmButtonText: '确定',
            })
            return
          }

          params = this.selectTableList.map(item =>{
            return {
              sellerId:item.sellerId,
              offerId:item.offerId,
            }
          })
        }
        let that = this
        this.$confirm('此操作将上架在线产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
            .then(() => {
              ajaxPost(
                  Baseurl + 'allegroOfferInfo/batchListing',
                  params
              ).then((res) => {
                if (res.data.code == 200) {
                  that.$message({
                    type: 'success',
                    message: '上架成功!',
                  })
                  that.get_table_data()
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消“上架”操作',
              })
            })
        console.log(999)

      },

      //自动换算
      clickHuansuan(scope){
        console.log(scope)
        let property = scope.column.property
        this.piliangList.forEach(item => {
          if (item.bolanPrice){
            if (property == 'siluofakePrice'){
              item.siluofakePrice = (item.bolanPrice * this.siluofakehuilv).toFixed(2)
            } else if (property == 'jiekePrice'){
              item.jiekePrice = (item.bolanPrice * this.jiekehuilv).toFixed(2)
            }
          }
        })
      },
      //获取汇率
      getBizhong(){
        const API = Baseurl + 'rateController/getAllRate'
        ajaxPost(API).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            let jieke = 1
            let siluofake = 1
            let bolan = 1
            data.forEach(item =>{
              if (item.currencyCode == 'CZK'){
                jieke = item.exchangeRate
              } else if (item.currencyCode == 'EUR'){
                siluofake = item.exchangeRate
              } else if (item.currencyCode == 'PLN'){
                bolan = item.exchangeRate
              }
            })
            this.jiekehuilv = (bolan/jieke).toFixed(4)
            this.siluofakehuilv = (bolan/siluofake).toFixed(4)
          }
        })
      },
      copyTextToClipboard(textToCopy) {
        console.log(textToCopy);
        // 使用 Clipboard API 复制文本
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
              // 复制成功后的处理
              this.$message.success('文本已复制到剪贴板');
            })
            .catch(err => {
              // 复制失败时的处理
              console.error('复制失败:', err);
              this.$message.error('复制失败');
            });
      },
		}
	}
</script>

<style lang="scss">
	@import "ozon.less";
	.Release {
		width: 98%;
		// background: #F7F7F7;
		padding-bottom: 72px;
		.summary_bag {
			width: 98%;
			margin: auto;
			.summary_complete_bag {
				overflow: hidden;
				.summary_complete {
					overflow: hidden;
					padding: 10px 0;
					border-bottom: 1px #eee solid;
					div {
						padding: 0 10px;
						height: 30px;
						border: #2c8dff 1px solid;
						line-height: 30px;
						text-align: center;
						color: #2c8dff;
						float: left;
						border-radius: 4px;
						cursor: pointer;
					}
					.active {
						background: #2c8dff;
						color: #fff;
					}
				}
			}
			.summary_pagenum {
				width: 100%;
				margin-bottom: 10px;
				overflow: hidden;
				background: #f5f5f5;
				.summary_query {
					width: 20%;
					float: left;
					padding: 0 10px;
					line-height: 32px;
					letter-spacing: 1px;
					color: #585858;
					span {
						color: #2c8dff;
					}
				}
				.block {
					float: right;
				}
			}
			.summary_content {
				width: 100%;
				border: 1px solid #eee;
				overflow: hidden;
				.summary_batch {
					width: 100%;
					overflow: hidden;
					border-bottom: 1px solid #eee;
					span {
						display: block;
						float: left;
						line-height: 20px;
						margin: 10px 0px;
						padding: 0 20px;
						color: #2c8dff;
						overflow: hidden;
						border-left: 1px #2c8dff solid;
					}
					span:nth-child(1) {
						color: #000;
						border-left: 0px;
					}
				}
			}
			.summary_list {
				.scope_img {
					width: 55px;
					height: 55px;
					margin: 0 auto;
					img {
						width: 100%;
						height: 100%;
					}
				}
				.oper {
					color: #2c8dff;
					margin-right: 10px;
					cursor: pointer;
				}
			}
		}
	}
	.item_sku{
		width: 100%;
	}
	.custom-formScreen {
		::v-deep {
			.el-form-item__content {
				width: calc(100% - 125px);
			}
		}
	}
	.zhankai_shouqi{
		width: 30px;
		height: 30px;
		border-radius: 5px;
		background: rgb(168,168,168);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 15px;
		cursor: pointer;
	}
	.item_yuan{
		width: 15px;
		height: 15px;
		border-radius: 50%;
		margin-left: 15px;
		cursor: pointer;
	}
	.red_yuan{
		background: red;
	}
	.green_yuan{
		background: green;
	}

	.scope_img {
		width: 55px;
		height: 55px;
		margin: 0 auto;
		img {
			width: 100%;
			height: 100%;
		}
	}
</style>
